import DrilldownItem from './DrilldownItem';
import { withClickToEdit, withCuration } from './DrilldownItem';

const DrilldownItemCte = withClickToEdit(DrilldownItem);

export { DrilldownItem, withClickToEdit, DrilldownItemCte };
export default withCuration(DrilldownItem);
